import React, { Fragment, useEffect, useState } from "react";
import UserPanel from "./user-panel";
import { Link } from "react-router-dom";
import { FileCopySharp } from "@mui/icons-material";
import {
  ADMIN_TESTING_MENUITEMS,
  ADMINMENUITEMS,
  ASMMENUITEMS,
  CEO_CFO_CSO_MENUITEMS,
  DISTRIBUTORMENUITEMS,
  FH_MENUITEMS,
  TDS_USER_MENUITEMS,
} from "../../../constants/menu";

// image import
import logo from "../../../assets/images/dashboard/LOGOMOD.png";
import { AP_ADMINMENUITEMS, AP_VENDORMENUITEMS, AP_VENDORMENUITEMS_NOT_ONBOARDED } from "../../../constants/menu_AP";

const Sidebar = () => {
  const isAsmUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 5 || //ASM
    JSON.parse(sessionStorage.getItem("userData")).groupId === 3 || //BM
    JSON.parse(sessionStorage.getItem("userData")).groupId === 4 || //BSM
    JSON.parse(sessionStorage.getItem("userData")).groupId === 6 || //BCM
    JSON.parse(sessionStorage.getItem("userData")).groupId === 11 || //AGENT
    JSON.parse(sessionStorage.getItem("userData")).groupId === 14 || //BBS
    JSON.parse(sessionStorage.getItem("userData")).groupId === 15; //NSM


  const isCEO_CFO_CSO_User =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 8 || //CEO
    JSON.parse(sessionStorage.getItem("userData")).groupId === 9 || // CFO
    JSON.parse(sessionStorage.getItem("userData")).groupId === 10; //CSO

  const isFinanceHead_User =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 7; // FH

  const isTDS_User =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 12; // FH

  const isARLocation =
    JSON.parse(sessionStorage.getItem("userData")).locationId === 1; // FH


    const isAPLocation =
    JSON.parse(sessionStorage.getItem("userData")).locationId === 2; // FH

    const isAdminTestGroup =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 2; // FH

    const isVendorUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 0;
  
  const isSAPAdmin =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 21;

    const hasVendorCode = isVendorUser && isAPLocation &&
    JSON.parse(sessionStorage.getItem("userData"))?.hasVendorCode === "Y";      

  const MENUITEMS = isAPLocation && isSAPAdmin
    ? [
        {
          path: "/dashboard",
          title: "Dashboard",
          icon: FH_MENUITEMS[0].icon,
          type: "link",
          badgeType: "primary",
          active: false,
        },
        {
          title: "Master",
          icon: FileCopySharp,
          type: "sub",
          active: false,
          children: [
            {
              path: "/master/vendorRegistrationList",
              title: "Vendor Registration",
              type: "link",
            },
          ],
        },
      ]
    : isARLocation
    ? isAsmUser
      ? ASMMENUITEMS
      : JSON.parse(sessionStorage.getItem("userData")).groupId === 0
        ? DISTRIBUTORMENUITEMS
        : isCEO_CFO_CSO_User
          ? CEO_CFO_CSO_MENUITEMS
          : isFinanceHead_User
            ? FH_MENUITEMS
            : isTDS_User
              ? TDS_USER_MENUITEMS
              : isAdminTestGroup? ADMIN_TESTING_MENUITEMS : ADMINMENUITEMS
    : isVendorUser? 
    hasVendorCode? AP_VENDORMENUITEMS : AP_VENDORMENUITEMS_NOT_ONBOARDED : AP_ADMINMENUITEMS;

  const [mainmenu, setMainMenu] = useState(MENUITEMS);
  const [isChange, setIsChange] = useState(false);

  useEffect(() => {
    const currentUrl = window.location.pathname;
    mainmenu.map((items) => {
      mainMenu.filter((Items) => {
        if (Items.path === currentUrl) setNavActive(Items);
        if (!Items.children) return false;
        Items.children.filter((subItems) => {
          if (subItems.path === currentUrl) setNavActive(subItems);
          if (!subItems.children) return false;
          subItems.children.filter((subSubItems) => {
            if (subSubItems.path === currentUrl) {
              setNavActive(subSubItems);
              return true;
            } else {
              return false;
            }
          });
          return subItems;
        });
        return Items;
      });
      return items;
    });
    return () => {
      setMainMenu(MENUITEMS);
    };
  }, [isChange]);

  const setNavActive = (item) => {
    setIsChange(!isChange);
    MENUITEMS.filter((menuItem) => {
      if (menuItem !== item) menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true;
      if (menuItem.children) {
        menuItem.children.filter((submenuItems) => {
          if (submenuItems !== item) {
            submenuItems.active = false;
          }
          if (submenuItems.children) {
            submenuItems.children.map(
              (childItem) => (childItem.active = false),
            );
            if (submenuItems.children.includes(item)) {
              submenuItems.active = true;
              menuItem.active = true;
            }
          }
          return false;
        });
      }
      return false;
    });
    item.active = !item.active;
    setMainMenu(MENUITEMS);
  };

  const mainMenu = mainmenu.map((menuItem, i) => (
    <li className={`${menuItem.active ? "active" : ""}`} key={i}>
      {menuItem.sidebartitle ? (
        <div className="sidebar-title">{menuItem.sidebartitle}</div>
      ) : (
        ""
      )}
      {menuItem.type === "sub" ? (
        <a
          className="sidebar-header "
          href="#javaScript"
          onClick={(event) => {
            event.preventDefault();
            return setNavActive(menuItem);
          }}
        >
          <menuItem.icon />
          <span>{menuItem.title}</span>
          <i className="fa fa-angle-right pull-right"></i>
        </a>
      ) : (
        ""
      )}
      {menuItem.type === "link" ? (
        <Link
          to={`${process.env.PUBLIC_URL}${menuItem.path}`}
          className={`sidebar-header ${menuItem.active ? "active" : ""}`}
          onClick={() => setNavActive(menuItem)}
        >
          <menuItem.icon />
          <span>{menuItem.title}</span>
          {menuItem.children ? (
            <i className="fa fa-angle-right pull-right"></i>
          ) : (
            ""
          )}
        </Link>
      ) : (
        ""
      )}
      {menuItem.children ? (
        <ul
          className={`sidebar-submenu ${menuItem.active ? "menu-open" : ""}`}
          style={
            menuItem.active
              ? { opacity: 1, transition: "opacity 500ms ease-in" }
              : {}
          }
        >
          {menuItem.children.map((childrenItem, index) => (
            <li
              key={index}
              className={
                childrenItem.children
                  ? childrenItem.active
                    ? "active"
                    : ""
                  : ""
              }
            >
              {childrenItem.type === "sub" ? (
                <a
                  href="#javaScript"
                  onClick={(event) => {
                    event.preventDefault();
                    return setNavActive(childrenItem);
                  }}
                >
                  <i className="fa fa-circle"></i>
                  {childrenItem.title}{" "}
                  <i className="fa fa-angle-right pull-right"></i>
                </a>
              ) : (
                ""
              )}

              {childrenItem.type === "link" ? (
                <Link
                  to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
                  className={childrenItem.active ? "active" : ""}
                  onClick={() => setNavActive(childrenItem)}
                >
                  <i className="fa fa-circle"></i>
                  {childrenItem.title}{" "}
                </Link>
              ) : (
                ""
              )}
              {childrenItem.children ? (
                <ul
                  className={`sidebar-submenu ${
                    childrenItem.active ? "menu-open" : "active"
                  }`}
                >
                  {childrenItem.children.map((childrenSubItem, key) => (
                    <li
                      className={childrenSubItem.active ? "active" : ""}
                      key={key}
                    >
                      {childrenSubItem.type === "link" ? (
                        <Link
                          to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
                          className={childrenSubItem.active ? "active" : ""}
                          onClick={() => setNavActive(childrenSubItem)}
                        >
                          <i className="fa fa-circle"></i>
                          {childrenSubItem.title}
                        </Link>
                      ) : (
                        ""
                      )}
                    </li>
                  ))}
                </ul>
              ) : (
                ""
              )}
            </li>
          ))}
        </ul>
      ) : (
        ""
      )}
    </li>
  ));

  return (
    <Fragment>
      <div className="page-sidebar">
        <div className="main-header-left d-none d-lg-block">
          <div className="logo-wrapper">
            <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
              <img className="blur-up lazyloaded" src={logo} alt="" />
            </Link>
          </div>
        </div>
        <div className="sidebar custom-scrollbar">
          <UserPanel />
          <ul className="sidebar-menu">{mainMenu}</ul>
        </div>
      </div>
    </Fragment>
  );
};

export default Sidebar;
